module.exports = __webpack_public_path__ + "2e6498fc.woff2";